module.exports = __webpack_public_path__ + "img/meeting.e025ec44.png";